import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-bmi-and-questionaire',
  templateUrl: './bmi-and-questionaire.component.html',
  styleUrls: ['./bmi-and-questionaire.component.scss']
})
export class BmiAndQuestionaireComponent implements OnInit {

  isLoading:boolean = false;
  BMIAndQuestionnaireInfo: any;
  constructor(
    private commonService: CommonService
  ) { }

  async ngOnInit() {
    this.isLoading = true;
    console.log('dfgdfgfd', this.commonService.claimReviewPolicyDetails);
    this.BMIAndQuestionnaireInfo = this.commonService.claimReviewPolicyDetails['lifes'][0];
    this.isLoading = false;
  }

}
